<template>
  <b-overlay
      :show="$store.getters['PTC_PermissaoAcessoClient/getIsLoading']"
  >
    <section id="card-text-alignment">
      <b-row>
        <b-col>
          <b-button
              variant="gradient-primary"
              :to="{ name: 'dashboard-ptc'}"
          >
            <feather-icon
                icon="ArrowLeftIcon"
                class="mr-50"
            />
            <span class="align-middle">Voltar</span>
          </b-button>
        </b-col>
      </b-row>
      <b-card
          title="Lista de Usuários Cadastrados"
          class="position-static mt-2 mb-4"
      >

        <b-table
            striped="striped"
            bordered="bordered"
            hover="hover"
            responsive="responsive"
            table-variant="secondary"
            :fields="fields"
            :items="$store.getters['PTC_PermissaoAcessoClient/getListaUsuarios']"
            show-empty
            empty-text="Nenhum registro encontrado"
        >
          <!-- A virtual column -->
          <template #cell(name)="data">
            {{ data.item.usuario_nome }}
          </template>

          <template #cell(email)="data">
            {{ data.item.usuario_email }}
          </template>

          <template #cell(ativo)="data">
            <div>
              <b-form-checkbox
                  :checked="data.item.usuario_ativo"
                  class="custom-control-success"
                  name="check-button"
                  switch
                  inline
                  :disabled="loadingStates[`ativo_${data.item.usuarioid}`]"
                  @change="toggleUsuarioAtivo(data.item)"
              />
              <b-spinner
                v-if="loadingStates[`ativo_${data.item.usuarioid}`]"
                small
                class="ml-1"
              />
            </div>
          </template>

          <template #cell(auth)="data">
            <div>
              <b-form-checkbox
                  :checked="data.item.usuario_autentica_ad"
                  class="custom-control-success"
                  name="check-button"
                  switch
                  inline
                  :disabled="loadingStates[`auth_${data.item.usuarioid}`]"
                  @change="toggleUsuarioAuth(data.item)"
              />
              <b-spinner
                v-if="loadingStates[`auth_${data.item.usuarioid}`]"
                small
                class="ml-1"
              />
            </div>
          </template>

          <template #cell(action)="data">
            <div
                class="d-flex"
                style="gap:5px"
            >
              <b-button
                  variant="gradient-primary"
                  title="Visualizar e Editar"
                  size="sm"
                  @click="$store.commit('PTC_PermissaoAcessoClient/SET_LISTA_USUARIO', data.item)"
                  :to="{ name: 'atualizar-usuario', params: { id: data.item.usuarioid } }"
              >
                <feather-icon icon="EyeIcon"/>
              </b-button>

              <b-button
                  variant="gradient-danger"
                  title="Deletar"
                  size="sm"
                  @click="confirmText(data.item)"
              >
                <feather-icon icon="TrashIcon"/>
              </b-button>
            </div>
          </template>
        </b-table>
        <b-row>
          <b-col>
            <b-button
                variant="gradient-success"
                :to="{ name: 'cadastrar-usuario'}"
            >
              <span class="align-middle">Cadastrar Novo</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </section>
  </b-overlay>
</template>
<script>
import PTC_PermissaoAcessosService from '@/services/PTC/PTC_PermissaoAcesso.service';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';

import Ripple from 'vue-ripple-directive';

const ptc_PermissaoAcessosService = new PTC_PermissaoAcessosService();
export default {
  name: 'viewPermissaoAcesso',
  data() {
    return {
      stickyHeader: true,
      noCollapse: false,
      loadingStates: {},
      fields: [
        { key: 'name', label: 'Usuário' },
        { key: 'email', label: 'Login' },
        { key: 'ativo', label: 'Ativo' },
        { key: 'auth', label: 'Autorizado' },
        { key: 'action', label: 'Ações' },
      ],
      items: [
        {
          name: 'jhon doe',
          email: 'jhon.doe@gmail.com',
          ativo: true,
          auth: true,
        },
        {
          name: 'miranda',
          email: 'miranda@gmail.com',
          ativo: false,
          auth: true,
        },
      ],
    };
  },
  mounted() {
    this.listUsers();
    this.$store.getters['auth/getUser'];
  },
  methods: {
    async listUsers() {
      await ptc_PermissaoAcessosService.listaUsuarios();
    },
    async toggleUsuarioAtivo(usuario) {
      const loadingKey = `ativo_${usuario.usuarioid}`;

      try {
        this.$set(this.loadingStates, loadingKey, true);

        const novoValor = usuario.usuario_ativo ? 0 : 1;
        const dadosParaEditar = {
          usuario_ativo: novoValor,
        };

        await ptc_PermissaoAcessosService.editarUsuario(usuario.usuarioid, dadosParaEditar);

        usuario.usuario_ativo = novoValor;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: `Status do usuário ${novoValor ? 'ativado' : 'desativado'} com sucesso!`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        });
        location.reload();
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Erro ao alterar status do usuário',
            icon: 'XIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.$set(this.loadingStates, loadingKey, false);
      }
    },
    async toggleUsuarioAuth(usuario) {
      const loadingKey = `auth_${usuario.usuarioid}`;

      try {
        this.$set(this.loadingStates, loadingKey, true);

        const novoValor = usuario.usuario_autentica_ad ? 0 : 1;
        const dadosParaEditar = {
          usuario_autentica_ad: novoValor,
        };

        await ptc_PermissaoAcessosService.editarUsuario(usuario.usuarioid, dadosParaEditar);

        usuario.usuario_autentica_ad = novoValor;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: `Autorização do usuário ${novoValor ? 'ativada' : 'desativada'} com sucesso!`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        });
        location.reload();
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Erro ao alterar autorização do usuário',
            icon: 'XIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.$set(this.loadingStates, loadingKey, false);
      }
    },
    confirmText(item) {
      this.$swal({
        title: 'Tem certeza?',
        text: 'Você não poderá reverter isso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, excluir!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteUsers(item.usuarioid);
          this.$swal({
            icon: 'success',
            title: 'Excluído!',
            text: 'O usuário foi excluído com sucesso.',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          });
        }
      });
    },
    async deleteUsers(id) {
      await ptc_PermissaoAcessosService.deletarUsuario(id);
      await this.listUsers();
    },
  },
};
</script>
